/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';

const { setSelectedApp } = createActions(
	{
		SET_SELECTED_APP: key => ({ key })
	},
	{
		prefix: 'WebsiteBridge'
	}
);

export { setSelectedApp };
